/**
 * Config class
 *
 * @property {string} loginUrl
 * @property {string} loginMethod
 * @property {function} dispatch
 */
class Config {

  constructor() {

    /**
     * @type {{?loginUrl: string, loginMethod: string, dispatch: Function, combineReducers: function}}
     * @private
     */

    const _config = {
      loginUrl:    null,
      loginMethod: 'POST',
      dispatch:    null, // Must be set
    };


    const getPropertyDefinition = (property) => ({

      configurable: false,

      enumerable: true,

      get: () => {

        if (!_config[property]) {

          throw new Error(
            `\`${property}\` not configured.  You must set config.${property} before attempting to use this value.`
          );

        }

        return _config[property];

      },

      set: (value) => _config[property] = value,

    });


    Object.defineProperties(this, {
      loginUrl:        getPropertyDefinition('loginUrl'),
      loginMethod:     getPropertyDefinition('loginMethod'),
      dispatch:        getPropertyDefinition('dispatch'),
    });

  }

}


export default new Config();


// WEBPACK FOOTER //
// ./src/modules/auth/config.js